import { render } from "./StepFive.vue?vue&type=template&id=728886e6"
import script from "./StepFive.vue?vue&type=script&lang=js"
export * from "./StepFive.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__